import React, { useEffect, useState } from "react";
import {
  Grid,
  CircularProgress,
  Divider,
  StepConnector,
  styled,
  stepConnectorClasses
} from "@mui/material";
import Box from "@mui/material/Box";
import { toast } from "react-toastify";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { BiSolidPhone } from "react-icons/bi";
import { CiCircleQuestion } from "react-icons/ci";

import {
  DarkGreenColorButton,
  GreenColorButton,
  PrimeGrayBorderColorButton,
} from "../../Components/MaterialButtonStyle/StyleButton";
import { OnlyDateConverter } from "../../Components/Helpers/DateTimeConverter";
import { FormatAmount } from "../../Components/Formatters/AmountFormat";

import CustomCheckBox from "../../Components/CheckBox/CustomCheckBox";
import CustomInput from "../../Components/CustomInputs/CustomInputs";
import CustomDropDown from "../../Components/DropDown/CustomDropDown";
import {
  GenderInfo,
  NigeriaStatesInfo,
  TitleInfo,
  MaritalStatusInfo
} from "../../Components/Templates/DataFile/Data";
import FileUploadButton from "../../Components/MaterialButtonStyle/UploadButton";
import EducationalQualification from "../../Components/Templates/EducationalQualification";
import CandidateOtherDetails from "./CandidateOtherDetails";
import PSCLogo from "../../Assets/Logo/PSCLogo.jpg";
import ApplicationDetails from "../Applications/ApplicationDetails";
import DatePicker from "../../Components/DateRangeSelector/DatePicker";
import CustomModal from "../../Components/Modal/CustomModal";
import AutoComplete from "../../Components/GoogleAutoComplete/AutoComplete";

import { formatDateToISO } from "../../Components/Helpers/DateTimeConverter";
import {
  PostMethod,
  GetPublicURL,
  S3Upload,
} from "../../Helper/api";
import LoaderModal from "../../Components/Modal/Loader";
import { useNavigate } from "react-router-dom";
const CandidateJob = () => {
  const navigate = useNavigate();

  const [stepper, setStepper] = useState(0);
  const [jobApplied, setJobApplied] = useState(true);
  const [ProfileIMAGES, setProfileIMAGES] = useState("");
  const [ProfileIMAGES1, setProfileIMAGES1] = useState("");
  const [Gender, setGender] = useState("");
  const [Affirmationcheck,setAffirmationcheck]=useState(false)
  const [basicDetails, setbasicDetails] = useState([]);
  const [KinDetails, setKinDetails] = useState([]);
  const [Workflow, setWorkflow] = useState([]);
  const [EducationQualification, setEducationQualification] = useState([]);
  const [informations, setinformations] = useState([]);
  const [furtherInformation, setFurtherInformation] = useState([]);
  const [Referees, setReferees] = useState([]);
  const [affirmation, setaffirmation] = useState();
  const [Loading, setLoading] = useState("");
  const [CandidateDetail, setCandidateDetail] = useState([]);
  const [EducationQualificationsInfo, setEducationQualificationsInfo] = useState([]);
  const [aggrement, setAggrement] = useState({
    Q1: false,
    Q2: false,
    Q3: false,
  });

  const [signature, setSignature] = useState("");
  const [placeName, setPlaceName] = useState("");
  const [submittedDate, setSubmittedDate] = useState("2025-01-28");
  const [conformModal, setConformModal] = useState(false);
  const [detailModal, setDetailModal] = useState("");
  const [jobDetails, setJobDetails] = useState(false);
  const [CandidateDetails, setCandidateDetails] = useState({});
  const [applicationAgreement, setApplicationAgreement] = useState(false);
  const [ShowLoader, setShowLoader] = useState(false);
  const [Job_application_id, setJob_application_id] = useState();

  const [PhysicalList, setPhysicalList] = useState([]);
  const [CBTList, setCBTList] = useState([]);
  const [medical_locations, setmedical_locations] = useState([]);
  const [physical_locations, setphysical_locations] = useState([]);
  const [computer_locations, setcomputer_locations] = useState([]);
  const [verifyApplications, setverifyApplications] = useState(false);
  const [NigeriaReligions, setNigeriaReligions] = useState([]);
  const [RelationshipData, setRelationshipData] = useState([]);
  const [Baseaddeess, setBaseaddeess] = useState(); 
  const [Residentialaddeess, setResidentialaddeess] = useState();

  const [referenceDetails, setReferenceDetails] = useState({
    fullName: "",
    Phone: "",
    Details: "",
    Address: "",
  });
  const [physicalTest, setPhysicalTest] = useState([]);
  const [otherDetails, setOtherDetails] = useState({
    location1: null,
    location2: null,
    location3: null,
    cityList: [],
    cityMedicialList: [],
    cityCbtList: [],
    cbtLocation1: null,
    cbtLocation2: null,
    cbtLocation3: null,
    selectedState: "",
    selectedCbtState: "",
    selectedMedicalState: "",
    medicalLocation1: null,
    medicalLocation2: null,
    medicalLocation3: null,
  });
  const [CandidateJobOpenings, setCandidateJobOpenings] = useState([]);
  const steps = [
    "Applicant Details",
    "Education Details",
    "Other Details",
    "Preview & Confirm",
  ];
  const ValidationEmails = (mail) => {
    /* eslint-disable */
    const regExp =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regExp.test(mail);
    /* eslint-enable */
  };
  const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 15,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: "#0FBE7C",
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: "#0FBE7C",
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 3,
      border: 0,
      backgroundColor: "rgba(224, 224, 224, .6)",
      borderRadius: 1,
      ...theme.applyStyles("dark", {
        backgroundColor: "rgba(224, 224, 224, .6)",
      }),
    },
  }));
  useEffect(() => {
    const date = new Date();
    const formattedDate = date.toISOString().split("T")[0]; 
    setSubmittedDate(formattedDate)
  }, []);
  const ApplicationComplete = async () => {

    try {
      basicDetails?.map((item) => {
        if(item.name!="Repeat Email" &&  item.name!="Other Phone Number"){
          if (item.input == "dropdown") {
            if (!item.value && item.value?.trim().length == 0) {
              throw new Error(`Please Select ${item.name}`);
            }
          } else if (item.input == "text") {
            if (item.name == "Email") {
              if (!ValidationEmails(item.value)) {
                toast.error("Please Enter Valid Email Address");
                return;
              }
            }
            if(item.name == "Other Languages Spoken"){
              console.log(item.name)
            }else{
              if (!item.value && item.value?.trim().length == 0) {
                throw new Error(`Please Enter Valid ${item.name} `);
              }
            }
          } else if (item.input == "phone") {
            if (!item.value && item.value?.trim().length == 0) {
              throw new Error(`Please Enter Valid ${item.name} `);
            }
          }
        }
        
      });
    } catch (Error) {
     
      toast.error(Error.message);
      return;
    }
    try {
      KinDetails?.map((item) => {
        if (item.input == "dropdown") {
          if (!item.value && item.value?.trim().length == 0) {
            throw new Error(`Please Select Next of Kin Detail ${item.name}`);
          }
        } else if (item.input == "text") {
          if (item.name == "Email") {
            if (!ValidationEmails(item.value)) {
              throw new Error(`Please Enter Valid Email Address ${item.name}`);
            }
          }
          if (!item.value && item.value?.trim().length == 0) {
            throw new Error(
              `Please Enter Valid Next of Kin Detail  ${item.name} `
            );
          }
        } else if (item.input == "phone") {
          if (!item.value && item.value?.trim().length == 0) {
            throw new Error(
              `Please Enter Valid  Next of Kin Detail ${item.name} `
            );
          }
          if (item.value?.trim().length != 10) {
            throw new Error(
              `Please Enter Valid  Next of Kin Detail ${item.name} `
            );
          }
        }
      });
    } catch (Error) {
      toast.error(Error.message);
      return;
    }
    if (Job_application_id) {
      setStepper(1);
    } else {
      try {
        const userid = localStorage.getItem("@userid");
        if (!userid) {
          toast.warn("User authentication Failed ");
          return;
        }
        let url = "application/create";
        let method = "POST";
        let params = {
          candidate_id: userid,
          job_id: jobDetails.job_id,
          applicant_image: CandidateDetails?.candidate_image,
          ip_address: "192.168.0.1",
          signature: signature.localImage,
          application_temp_id: jobDetails.application_temp_id,
          workflow: Workflow,
          applicant_temp_details: basicDetails,
          kin_details: KinDetails,
        };
        setShowLoader(true);
        const response = await PostMethod({ url, method, params });
        if (response.status) {
          setJob_application_id(response.job_application_id);
          setStepper(1);
          setShowLoader(false);
        } else {
          toast.error("Something went wrong, please try again")
          setShowLoader(false);
        }
      } catch (Error) {
        toast.error("Something went wrong, please try again")
        console.log("Error", Error);
      }
    }
  };
  const EducationComplete = async () => {
    if (Job_application_id) {
      
      try {
        EducationQualification.map((row,i) => {
          if(!row?.courseName|| String(row?.courseName)?.trim()?.length==0){
            throw new Error(`Please Enter valid course Name in row ${i+1}`);
          }
          if(!row?.sittings|| String(row?.sittings)?.trim()?.length==0){
            throw new Error(`Select Number of Sittings for row ${i+1}`);
          }
          if(!row?.certificateNumber|| String(row?.certificateNumber)?.trim()?.length==0){
            throw new Error(`Enter Certificate Number for  row ${i+1}`);
          }
          if(!row?.certificateAttachmentURL|| String(row?.certificateAttachmentURL)?.trim()?.length==0){
            throw new Error(`Upload Certificate Attachment for row ${i+1}`);
          }
          if(!row?.institutionName|| String(row?.institutionName)?.trim()?.length==0){
            throw new Error(`Enter School / Institute Name for row ${i+1}`);
          }
          if(!row?.startedOn|| String(row?.startedOn)?.trim()?.length==0){
            throw new Error(`Select Course Started Date for for row ${i+1}`);
          }
          if(!row?.finishedOn|| String(row?.finishedOn)?.trim()?.length==0){
            throw new Error(`Select Course End Date for for row ${i+1}`);
          }
          row?.table?.map((item)=>{
            if(!item?.Credit|| String(item?.Credit)?.trim()?.length==0){
              throw new Error(`Select the Subject and Minimum Credit row ${i+1}`);
            }
          })
         
        });
      } catch (err) {
        toast.error(err.message);
        return;
      }
    
      let url = "application/edit";
      let method = "PUT";
      let params = {
        job_application_id: Job_application_id,
        applicant_image: ProfileIMAGES,
        ip_address: "192.168.0.1",
        status: "pending",
        signature: signature.localImage,
        workflow: 1,
        computer_assessment: [
          { name: "Number of Questions", value: "" },
          { name: "Test Duration", value: "" },
        ],
        education_qualification: EducationQualification,
        applicant_temp_details: basicDetails,
        kin_details: KinDetails,
        physical_test: [],
        medical_test: [],
        computer_test: [],
        fitness_requirement: [],
        further_information: informations,
        referee_information: Referees,
        physical_test_state: "Lagos",
        computer_test_state: "Ikeja",
        medical_test_state: "Ikeja",
        medical_locations: medical_locations,
        physical_locations: physical_locations,
        computer_locations: computer_locations,
      };
      try {
        setShowLoader(true);
        const response = await PostMethod({ url, method, params });
        if (response.status) {
          setStepper(2);
          setShowLoader(false);
        } else {
          setShowLoader(false);
          toast.error("something went wrong please try again");
        }
      } catch (Error) {
        setShowLoader(false);
        console.log("Error", Error);
        toast.error("something went wrong please try again");
      }
    }
  };
  const CompleteOtherDetails = async () => {
 
    if (!otherDetails) {
      toast.error("Please Select State ");
      return;
    }
    
    if (physicalTest.length == 0) {
      toast.error("Try Again");
      return;
    }

    try {
      
      physicalTest.map((row) => {
        if (row.input == "input") {
          if (!row?.value) {
            throw new Error(`Please Enter ${row.name}`);
          }
          if (row?.value?.trim().length === 0) {
            throw new Error(`Please Enter Valid ${row.name}`);
          }
        } else if (row.input == "checkbox") {
          if (!row?.value) {
            throw new Error(`Please Select ${row.name}`);
          }
          if (row?.value?.trim().length === 0) {
            throw new Error(`Please Select Valid ${row.name}`);
          }
        }
      });
    } catch (err) {
      toast.error(err.message);
      return;
    }
    if (!referenceDetails) {
      toast.error("Try Again");
      return;
    }

    if (referenceDetails.fullName) {
      if (referenceDetails.fullName?.trim()?.length == 0) {
        toast.error("Please Enter Referee's Information Valid Full Name");
        return;
      }
    }
    if (referenceDetails.Phone) {
      if (referenceDetails.Phone?.trim()?.length == 0) {
        toast.error("Please Enter Referee's Information Valid Phone Number");
        return;
      }
    }
    if (referenceDetails.Address) {
      if (referenceDetails.Address?.trim()?.length == 0) {
        toast.error("Please Enter Referee's Information Valid Address");
        return;
      }
    }
    if (referenceDetails.Details) {
      if (referenceDetails.Details?.trim()?.length == 0) {
        toast.error("Please Enter Referee's Information Valid Details");
        return;
      }
    }

    if (furtherInformation.length == 0) {
      toast.error("Try Again");
      return;
    }

    try {
      furtherInformation.map((row) => {
        if (row.input == "check") {
          if (!row?.value) {
            throw new Error(`Please Select ${row.name}`);
          }

          if (row.value?.toLowerCase() == "yes") {
            if (!row?.name1Value) {
              throw new Error(`Please Give Details for ${row.name}`);
            }
            if (row?.name1Value?.trim()?.length == 0) {
              throw new Error(`Please Give Valid Details for ${row.name}`);
            }

            if (row?.name2) {
              if (!row?.name2Value) {
                throw new Error(
                  `Please Enter Reason for Leaving for ${row.name}`
                );
              }
              if (row?.name2Value?.trim()?.length == 0) {
                throw new Error(
                  `Please Enter Valid Reason for Leaving for ${row.name}`
                );
              }
            }
          }
        }
        if (row.input == "year") {
          if (!row?.year) {
            throw new Error(`Please Enter ${row.name} Year Value`);
          }
          if (row?.year?.length == 0) {
            throw new Error(`Please Enter ${row.name} Valid Year Value`);
          }
          if (!row?.month) {
            throw new Error(`Please Enter ${row.name} Month Value`);
          }
          if (row?.month?.length == 0) {
            throw new Error(`Please Enter ${row.name} Valid Month Value`);
          }
        }
      });
    } catch (err) {
      toast.error(err.message);
      return;
    }
    if (!Job_application_id) {
      toast.error("Something went wrong try again later");
      return;
    }
    if(referenceDetails?.Phone){
      if(String(referenceDetails?.Phone).length>0 && String(referenceDetails?.Phone).length !=10){
        toast.error("Enter Valid Referee’s Information Phone");
        return;
      }
    }
    try {
      let referenceDetailsset = [
        {
          name: "Full Name",
          value: referenceDetails.fullName,
          input: "text",
        },
        {
          name: "Phone",
          value: referenceDetails.Phone,
          input: "phone",
        },
        {
          name: "Address",
          value: referenceDetails.Address,
          input: "address",
        },
        {
          name: "Give details (if Yes)",
          value: referenceDetails.Details,
          input: "textarea",
        },
      ];
      setReferees(referenceDetailsset)
      let url = "application/edit";
      let method = "PUT";
      let params = {
        job_application_id: Job_application_id,
        applicant_image: ProfileIMAGES,
        ip_address: "192.168.0.1",
        status: "pending",
        signature: signature.localImage,
        workflow: 1,
        computer_assessment: [
          { name: "Number of Questions", value: "" },
          { name: "Test Duration", value: "" },
        ],
        education_qualification: EducationQualification,
        applicant_temp_details: basicDetails,
        kin_details: KinDetails,
        physical_test: physicalTest,
        medical_test: [],
        computer_test: [],
        fitness_requirement: physicalTest,
        further_information: furtherInformation,
        referee_information: referenceDetailsset,
        physical_test_state: otherDetails.selectedState,
        computer_test_state: otherDetails.selectedCbtState,
        medical_test_state: otherDetails.selectedMedicalState,
        physical_locations: [
          { value: otherDetails.location1 },
          { value: otherDetails.location2 },
          { value: otherDetails.location3 },
        ],
        medical_locations: [
          { value: otherDetails.medicalLocation1 },
          { value: otherDetails.medicalLocation2 },
          { value: otherDetails.medicalLocation3 },
        ],
        computer_locations: [
          { value: otherDetails.cbtLocation1 },
          { value: otherDetails.cbtLocation2 },
          { value: otherDetails.cbtLocation3 },
        ],
      };
      try {
        setphysical_locations([
          { value: otherDetails.location1 },
          { value: otherDetails.location2 },
          { value: otherDetails.location3 },
        ])
        setcomputer_locations([
          { value: otherDetails.cbtLocation1 },
          { value: otherDetails.cbtLocation2 },
          { value: otherDetails.cbtLocation3 },
        ])
        setmedical_locations([
          { value: otherDetails.medicalLocation1 },
          { value: otherDetails.medicalLocation2 },
          { value: otherDetails.medicalLocation3 },
        ])
        setShowLoader(true);
        const response = await PostMethod({ url, method, params });
        if (response.status) {
          setStepper(3);
          setShowLoader(false);
        } else {
          setShowLoader(false);
          toast.error("something went wrong please try again");
        }
      } catch (Error) {
        setShowLoader(false);
        console.log("Error", Error);
        toast.error("something went wrong please try again");
      }
    } catch (Error) {
      console.log("Error", Error);
    }
    setStepper(3);
  };
  const CompletePreview = async () => {
    if(!Affirmationcheck){
      toast.error("Please Select the Affirmation");
      return;
    }
    if (!submittedDate) {
      toast.error("Please Select Submitted Date");
      return;
    }
    if (!placeName) {
      toast.error("Please Enter Submitted on Place Name");
      return;
    }
    if (placeName?.Address?.trim()?.length == 0) {
      toast.error("Please Enter Valid Submitted on Place Name");
      return;
    }
  
    setConformModal(true);
  };
  const HandleAttachmentValueChange = async (value) => {
    const files = value.target.files && value.target.files[0];
    if (files) {
      const maxFileSize = 1 * 1024 * 1024;
      if (files.size > maxFileSize) {
        toast.error("File size exceeds 1MB. Please upload a smaller file.");
        return;
      }
      let today = Date.now();
      let Extention = String(files.name).split(".");
      let extension = Extention[Extention.length - 1];

      let fileUrl = "Attachment/attachment" + today + "." + extension;
      const reader = new FileReader();
      const img = new Image();
      setShowLoader(true);
      let name = "signatures/attachment" + today + "." + extension;
      let contenttype = "application/pdf";
      if (extension != "pdf") {
        contenttype = "image/png";
      }
      
      try {
        const data = await S3Upload({
          name,
          file: value.target.files[0],
          contenttype,
        });
        const Imagess = await GetPublicURL(data)
        setSignature({ fileUrl: fileUrl, localImage: data,previewimage:Imagess });
        reader.onload = async (e) => {
          img.src = e.target.result;
          img.onload = async () => {};
        };
        reader.readAsDataURL(files);
        setShowLoader(false);
      } catch (Error) {
        console.log("Error",Error)
        toast.error("Something went wrong try again");
        setShowLoader(false);
      }
    }
  };
  const ChangeAggrement = (value, field) => {
    setAggrement((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };
  const HandleComplete = async () => {
    try {
      let url = "application/edit";
      let method = "PUT";
      let params = {
        job_application_id: Job_application_id,
        applicant_image: ProfileIMAGES,
        ip_address: "192.168.0.1",
        signature: signature.localImage,
        status: "submitted",
        workflow: 1,
        computer_assessment: [
          { name: "Number of Questions", value: "" },
          { name: "Test Duration", value: "" },
        ],
        education_qualification: EducationQualification,
        applicant_temp_details: basicDetails,
        kin_details: KinDetails,
        physical_test: physicalTest,
        medical_test: [],
        computer_test: [],
        fitness_requirement: physicalTest,
        further_information: informations,
        referee_information: Referees,
        physical_test_state: otherDetails.selectedState,
        computer_test_state: otherDetails.selectedCbtState,
        medical_test_state: otherDetails.selectedMedicalState,
        physical_locations: [
          { value: otherDetails.location1 },
          { value: otherDetails.location2 },
          { value: otherDetails.location3 },
        ],
        medical_locations: [
          { value: otherDetails.medicalLocation1 },
          { value: otherDetails.medicalLocation2 },
          { value: otherDetails.medicalLocation3 },
        ],
        computer_locations: [
          { value: otherDetails.cbtLocation1 },
          { value: otherDetails.cbtLocation2 },
          { value: otherDetails.cbtLocation3 },
        ],
        submited_place: placeName.Address,
        submited_on: true,
      };
      setConformModal(false);
      setShowLoader(true);
      const response = await PostMethod({ url, method, params });
      if (response.status) {
        setJobApplied(true);
        setStepper(0);
        setJobDetails("");
        setAggrement({ Q1: false, Q2: false, Q3: false });
        setSubmittedDate("");
        setPlaceName("");
        setReferenceDetails({
          fullName: "",
          Phone: "",
          Details: "",
          Address: "",
        });
        setOtherDetails({
          selectedState: "",
          location1: null,
          location2: null,
          location3: null,
          cityList: [],
          cityMedicialList: [],
          cityCbtList: [],
          selectedCbtState: "",
          cbtLocation1: null,
          cbtLocation2: null,
          cbtLocation3: null,
          selectedMedicalState: "",
          medicalLocation1: null,
          medicalLocation2: null,
          medicalLocation3: null,
        });
        setFurtherInformation([]);
        setPhysicalTest([]);
        GetJobLists()
        toast.success("Job Applied Successfully");
        setShowLoader(false);
      } else {
        setShowLoader(false);
        if (response.message) {
          toast.error(response.message);
        } else {
          toast.error("Something went wrong try again");
        }
      }
    } catch (Error) {
      setShowLoader(false);
      toast.error("Something went wrong try again");
      console.log("CompletePreview", Error);
    }
  };
  const OpenApplication = async () => {
    if (!aggrement.Q1 || !aggrement.Q2 || !aggrement.Q3) {
      toast.error("Please Agree All the Instruction Conditions Before Proceed");
      return;
    }
    const userid = localStorage.getItem("@userid");
    if (!userid) {
      toast.warn("User authentication Failed ");
      return;
    }
    try {
      if (!jobDetails.job_uuid) {
        toast.error("Something went wrong try again later");
        return;
      }
      setinformations([])
      setWorkflow([])
      console.log("Gender",Gender)
      navigate("/apply/"+jobDetails.job_uuid)
    } catch (Error) {
      setverifyApplications(false);
      console.log("Error in OpenApplication", Error);
    }
  };
  const OpenDetailModal = (data) => {
    setDetailModal(true);
    setJobDetails(data);
  };
  const CloseDetailModal = () => {
    setDetailModal(false);
    setJobDetails("");
    setAggrement({ Q1: false, Q2: false, Q3: false });
  };
  const OpenAgreementModal = (data) => {
    setApplicationAgreement(true);
    setJobDetails(data);
  };
  const CloseAgreementModal = () => {
    setDetailModal(false);
    setApplicationAgreement("");
  };
  const PreviewBack = () => {
    setStepper(2);
  };
  useEffect(() => {
    GetJobLists();
    GetcandidateDetails();
   
    GetReligion();
    Getrelationship();
    GetEducations()
  }, []);
  const GetAdddresslist = async (candidate_state) => {
    try {
      let url = "settings/baseaddresslist";
      let method = "POST";
      let params = {
        type: "physical",
      };
      const response = await PostMethod({ url, method, params });
      if (response.status) {
        let array = [];
        response?.result.map((item) => {
          if(candidate_state){
            if(String(item.base_address_state)?.toLowerCase()==String(candidate_state).toLowerCase()){
              array.push({ value: item.base_address, label: item.base_address });
            }
          }else{
            array.push({ value: item.base_address, label: item.base_address });
          }
        });
        setPhysicalList(array);
      }
      let url1 = "settings/baseaddresslist";
      let method1 = "POST";
      let params1 = {
        type: "cbt",
      };
      const response1 = await PostMethod({
        url: url1,
        method: method1,
        params: params1,
      });
      if (response1.status) {
        let arrays = [];
        response1?.result.map((item) => {
          if(candidate_state){

            if(String(item.base_address_state)?.toLowerCase()==String(candidate_state).toLowerCase()){
              arrays.push({ value: item.base_address, label: item.base_address });
            }
          }else{
            arrays.push({ value: item.base_address, label: item.base_address });
          }
        });
        setCBTList(arrays);
      }
    } catch (Error) {
      console.log("Error in GetAdddresslist", Error);
    }
  };
  const GetJobLists = async () => {
    const Userid =localStorage.getItem("@userid")
    try {
      let url = "job/list";
      let method = "POST";
      let params ={
        candidate_uuid:Userid
      }
      setLoading(true)
      const response = await PostMethod({ url, method,params });
     
      if (response.status) {
        if(response?.appliedjob){
          let arrays =[]
          let arraystatus =[]
          response.appliedjob?.map((job)=>{
            arrays.push(job.job_id)
            arraystatus.push(job.job_current_status)
          })
          response.result?.map((job)=>{
            if(arrays.indexOf(job.job_id)!=-1){
              if(arraystatus[arrays.indexOf(job.job_id)]=="pending"){
                job.PendingStatus =true
                job.jobcreated_Status = false
              }else{
                job.jobcreated_Status = true
              }
            }else{
              job.jobcreated_Status = false
            }
            if(job.pause_status){
              job.jobcreated_Status = true
            }
          })
        }
        setLoading(false)
        setCandidateJobOpenings(response.result);
      } else {
        setLoading(false)
      }
    } catch (Error) {
      setLoading(false)
      console.log("Error", Error);
    }
  };
  const GetcandidateDetails = async () => {
    try {
      const userid = localStorage.getItem("@userid");
      if (!userid) {
        toast.warn("User authentication Failed ");
        return;
      }
      let url = "candidate/candidateDetails";
      let method = "POST";
      let params = {
        candidate_uuid: userid,
      };
      const response = await PostMethod({ url, method, params });

      if (response.status) {
       
        if(response.result?.candidate_state){
          GetAdddresslist(response.result?.candidate_state)
        }

        if(response.result?.candidate_image){
          const responses = await GetPublicURL(response.result.candidate_image)
      
          setProfileIMAGES1(responses);
          setProfileIMAGES(response.result.candidate_image);
        }
        setCandidateDetails(response.result);
        if (response?.result.candidate_gender) {
          setGender(response?.result.candidate_gender);
        }
      }
    } catch (Error) {
      console.log("err in GetcandidateList", Error);
    }
  };
  const HandleBasicinfo = (value, index) => {
    const datas = [...basicDetails];
    datas[index].value = value;
    setbasicDetails(datas);
  };
  const HandleBasicinfoCheck = (value, index,) => {
    const datas = [...basicDetails];
    let array =[]
    if(datas[index].value){
      array = datas[index].value
      if(array?.indexOf(value)!=-1){
        array.splice(array.indexOf(value),1)
      }else{
        array.push(value)
      }
    }else{
      array.push(value)
    }
    datas[index].value = array;
    setbasicDetails(datas);
  };
  const HandleKindetails = (value, index) => {
    const datas = [...KinDetails];
    datas[index].value = value.Address;
    setKinDetails(datas);
  };
  const GetReligion = async () => {
    try {
      let url = "settings/listeducation";
      let method = "POST";
      let params = {
        type: "religions",
      };
      const response = await PostMethod({ url, method, params });
      if (response.status) {
        let array = [];
        response.result?.map((item) => {
          array.push({
            value: item.education_name,
            label: item.education_name,
          });
        });
        setNigeriaReligions(array);
      }
    } catch (Error) {
      console.log("Error", Error);
    }
  };
  const Getrelationship = async () => {
    try {
      let url = "settings/listeducation";
      let method = "POST";
      let params = {
        type: "relationship",
      };
      const response = await PostMethod({ url, method, params });
    
      if (response.status) {
        let array = [];
        response.result?.map((item) => {
          array.push({
            value: item.education_name,
            label: item.education_name,
          });
        });
        setRelationshipData(array);
      }
    } catch (Error) {
      console.log("Error", Error);
    }
  };
  const GetEducations = async () => {
    try {
      let url = "settings/listeducation";
      let method = "POST";
      let params = {
        type: "qualification",
      };
      const response = await PostMethod({ url, method, params });
     
      if (response.status) {
        let array = [];
        response.result?.map((item) => {
          array.push({
            value: item.education_name,
            label: item.education_name,
          });
        });
        setEducationQualificationsInfo(array);
      }
    } catch (Error) {
      console.log("Error", Error);
    }
  };
  const Handleaddress = (value) => {
    HandleKindetails(value.Address, 5);
    setBaseaddeess(value);
  };
  const HandleaddressPermanent = (value, index) => {
    HandleBasicinfo(value.Address, index);

  };
  const HandleaddressResidential = (value, index) => {
    HandleBasicinfo(value.Address, index);
    setResidentialaddeess(value);
  };
  const GoBacktopage =()=>{
    if(stepper!=0){
      setStepper(stepper-1)
    }
  }
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = ""; // For older browsers
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  useEffect(()=>{
    if(stepper==3){
      const formattedArray = [
        basicDetails.reduce((result, item) => {
          const sanitizedKey = item.name.replace(/\s+/g, ""); // Remove spaces from the key
          result[sanitizedKey] = item.value; // Assign the value to the sanitized key
          return result;
        }, {})
      ];
      setCandidateDetail(formattedArray[0])
    }
  },[stepper])
  let maxDate = formatDateToISO(new Date())
  return (
    <Grid item>
      <LoaderModal ShowLoader={ShowLoader} setShowLoader={setShowLoader} />
      {jobApplied ? (
        <Grid
          item
          container
          justifyContent={"space-between"}
          className="bg-white borderRadius10"
        >
          <Grid item lg={12} md={12} sm={12} xs={12} container className="p-3">
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <h4 className="Text-Prime-Black poppinsMedium text-left">
                Job Openings
              </h4>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12} className="py-3">

              <p className="Text-Prime-Black poppinsRegular text-left pt-2">
                The Police Service Commission (PSC), in pursuance of its
                Constitutional Mandate, invites applications from suitably
                qualified Nigerians for enlistment into the Nigeria Police Force
                in the following categories:
              </p>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12} className="pb-3">
              <p className="Text-Prime-Black poppinsMedium text-left">
                1.Cadet Assistant Superintendent of Police (ASP)
              </p>
              <p className="Text-Prime-Black poppinsMedium text-left pt-2">
                2.Cadet Inspector of Police
              </p>
              <p className="Text-Prime-Black poppinsMedium text-left pt-2">
                3.Police Constable
              </p>
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="pb-2"
              container
              flexDirection={"row"}
            >
              <p className="Text-Prime-Red poppinsMedium text-left ">NOTE: </p>
              <p className="Text-Prime-Black poppinsMedium px-2">
                {" "}
                An applicant can apply for ONLY ONE of any of these 3
                categories. You are therefore advised to carefully choose the
                category you are eligible for, as multiple applications would
                lead to disqualifications.
              </p>
            </Grid>
            <Grid
              item
              container
              lg={12}
              flexWrap={"wrap"}
              justifyContent={"center"}
            >
              {Loading&&  <CircularProgress size="2rem" style={{ color: "#000" }} />}
            </Grid>
            <Grid
              item
              container
              lg={12}
              flexWrap={"wrap"}
              justifyContent={"space-between"}
            >
              {CandidateJobOpenings.length > 0 ? (
                CandidateJobOpenings?.map((val, index) => (
                  <Grid
                    item
                    container
                    key={index}
                    lg={3.9}
                    md={3.9}
                    sm={12}
                    className="bg-white borderRadius10 my-3"
                    sx={{ boxShadow: "0px 4px 28.3px 0px #A0B8A799" }}
                  >
                    <Grid item container lg={12} className="p-3">
                      <h3 className="Text-Prime-Green poppinsMedium text-left">
                        {val?.job_name}
                      </h3>
                      <Grid item container lg={12} className="mt-3">
                        <Grid
                          item
                          container
                          lg={6}
                          sm={6}
                          flexDirection={"column"}
                        >
                          <p className="Text-Prime-Gray poppinsMedium text-left">
                            Closing Date
                          </p>
                          <p
                            className="Text-Prime-Gray poppinsMedium pt-2 text-left"
                            style={{ color: "#E77E72" }}
                          >
                            {val?.job_end_date
                              ? OnlyDateConverter(Number(val?.job_end_date))
                              : "--"}
                          </p>
                        </Grid>
                        <Grid
                          item
                          container
                          lg={6}
                          sm={6}
                          flexDirection={"column"}
                        >
                          <p className="Text-Prime-Gray poppinsMedium text-left">
                            No. of Openings
                          </p>
                          <p className="Text-Prime-Green poppinsMedium pt-2 text-left">
                            {val?.openings_count
                              ? FormatAmount(val?.openings_count)
                              : "--"}
                          </p>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Divider
                      className="mt-2 w-100"
                      sx={{ border: "1px solid #a7aba96e" }}
                    />
                    <Grid item container lg={12}>
                      <Grid
                        item
                        container
                        className="pt-3"
                        lg={12}
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"space-between"}
                        alignItems={"flex-start"}
                      >
                        <ul>
                          {val.job_qualifications?.slice(0,3)?.map((row, i) => {
                            return (
                              <li
                                key={i}
                                className="Text-Prime-Black poppinsRegular text-left pb-3"
                              >
                                {row?.name}
                              </li>
                            );
                          })}
                        </ul>
                      </Grid>
                      <Grid item className="py-3" lg={12}>
                        <p
                          className={
                            "TextUnderGreen pointer poppinsRegular text-center"
                          }
                          role="presentation"
                          onClick={() => OpenDetailModal(val)}
                        >
                          View More
                        </p>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        justifyContent={"center"}
                        sx={{ padding: "0% 4% 4% 4%" }}
                      >
                        <GreenColorButton
                          className="py-2 w-100"
                          disabled={val.jobcreated_Status}
                          onClick={() => OpenAgreementModal(val)}
                        >
                          <h4>{val.jobcreated_Status? "Already Applied" :val.PendingStatus?"Continue": "Apply"}</h4>
                        </GreenColorButton>
                      </Grid>
                    </Grid>
                  </Grid>
                ))
              ) : (
                <Grid
                  item
                  container
                  lg={12}
                  flexDirection={"column"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <h5 className="text-black poppinsMedium mt-3 mb-3">
                    No Jobs List Available
                  </h5>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid
          item
          container
          justifyContent={"space-between"}
          className="bg-white borderRadius10"
        >
          <Grid item lg={12} md={12} sm={12} xs={12} container className="p-3">
            <Box sx={{ width: "100%" }}>
              <Stepper
                activeStep={stepper}
                alternativeLabel
                connector={<CustomConnector activeStep={stepper} />}
              >
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel
                      sx={{
                        "& .MuiStepLabel-label.Mui-active": {
                          color: "#A7ABA9",
                          fontFamily: "PoppinsMedium",
                        },
                        "& .MuiStepLabel-iconContainer .Mui-active": {
                          color: "#A7ABA9",
                          fontFamily: "PoppinsMedium",
                        },
                        "& .MuiStepLabel-label.Mui-completed": {
                          color: "#222222",
                          fontFamily: "PoppinsMedium",
                        },
                        "& .MuiStepLabel-label": {
                          fontFamily: "PoppinsMedium",
                        },
                        "& .MuiStepLabel-iconContainer .Mui-completed": {
                          color: "#0FBE7C",
                          fontFamily: "PoppinsMedium",
                        },
                      }}
                    >
                      {label}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              className="p-3 borderRadius10 mt-3"
              backgroundColor={"#3B82F60A"}
            >
              <h5
                className="Text-Prime-Black poppinsMedium text-center p-2"
                style={{ textDecoration: "underline" }}
              >
                {/* Cadet Assistant Superintendent of Police - Examination */}
                {jobDetails.job_name}
              </h5>
            </Grid>
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              className="p-3 borderRadius10 mt-3"
            >
              <h5 className="Text-Prime-Black poppinsMedium text-left pt-2">
                {stepper == 0
                  ? "Applicant Details"
                  : stepper == 1 ? "Educational Qualification"  : stepper == 2? "Other Details": "Preview"}
              </h5>
            </Grid>
            <Divider
              className="m-1 mb-3 w-100"
              sx={{ border: "1px solid #a7aba96e" }}
            />

            {stepper == 0 ? (
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid
                  item
                  container
                  lg={12}
                  xs={12}
                  justifyContent={"space-between"}
                  className="py-3"
                >
                  <Grid
                    item
                    container
                    lg={5.9}
                    xs={5.9}
                    className="p-3"
                    sx={{ backgroundColor: "#3B82F60A", borderRadius: "6px" }}
                    alignItems={"flex-start"}
                    alignContent={"flex-start"}
                  >
                    <h5 className="Text-Prime-Black poppinsMedium text-left pt-2">
                      Upload Photo
                    </h5>
                    <Divider
                      className="mt-2 w-100"
                      sx={{ border: "1px solid #a7aba96e" }}
                    />
                    <Grid
                      item
                      container
                      lg={12}
                      xs={12}
                      justifyContent={"center"}
                      className="mt-3"
                    >
                      {ProfileIMAGES1 && (
                        <img
                          src={ProfileIMAGES1}
                          alt="profile"
                          height={"150px"}
                          width={"150px"}
                          className="img_fluid"
                        />
                      )}
                    </Grid>
                    <Grid item container lg={12} xs={12} className="mt-3">
                      <p className="poppinsRegular Text-Prime-Gray text-left">
                        This photo has been taken from your profile details. To update it, please edit your profile details..{" "}
                      </p>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    container
                    lg={5.9}
                    xs={5.9}
                    className="p-3"
                    sx={{ backgroundColor: "#3B82F60A", borderRadius: "6px" }}
                    alignItems={"flex-start"}
                    alignContent={"flex-start"}
                  >
                    <h5 className="Text-Prime-Black poppinsMedium text-left pt-2">
                      Upload Signature
                    </h5>
                    <Divider
                      className="mt-2 w-100"
                      sx={{ border: "1px solid #a7aba96e" }}
                    />
                    <Grid
                      item
                      container
                      lg={12}
                      xs={12}
                      flexDirection={"row"}
                      justifyContent={"center"}
                      className="mt-3"
                    >
                      {signature ? (
                        <Grid
                          item
                          container
                          lg={12}
                          xs={12}
                          justifyContent={"center"}
                          className="my-3"
                        >
                          {signature?.previewimage&&<img
                            src={
                              signature?.previewimage
                                ? signature.previewimage 
                                : null
                            }
                            alt="Signature"
                            style={{
                              width: "302px",
                              height: "98px",
                              border: "1px solid #666666",
                            }}
                            className="img_fluid"
                          />}
                        </Grid>
                      ) : (
                        <Grid
                          item
                          container
                          lg={6}
                          xs={6}
                          justifyContent={"center"}
                          border="1px solid #666666"
                          className="my-3"
                        >
                          <h5 className="Text-Prime-Black poppinsMedium text-left p-3">
                            Signature Not Upload
                          </h5>
                        </Grid>
                      )}
                      
                      <Grid
                        item
                        container
                        lg={12}
                        xs={12}
                        justifyContent={"center"}
                      >
                        <FileUploadButton
                          className="px-3 py-2 w-50"
                          placeholder={"Choose Signature"}
                          multiple={false}
                          accept="image/jpeg,image/png"
                          startIcon={true}
                          endIcon={false}
                          onClick={(e) => HandleAttachmentValueChange(e)}
                        />
                      </Grid>
                    </Grid>
                    
                    <Grid
                      item
                      container
                      lg={12}
                      xs={12}
                      flexDirection={"row"}
                      justifyContent={"flex-start"}
                      alignContent={"flex-start"}
                      flexWrap={"nowrap"}
                      overflow={"hidden"}
                      className="mt-3"
                    >
                      <p className="Text-Prime-Red poppinsMedium text-left">
                        NOTE:
                      </p>

                      <p className="Text-Prime-Black poppinsMedium ml-2">
                         The maximum file size allowed is 1mb.
                      </p>
                  
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  container
                  lg={12}
                  xs={12}
                  className="p-3"
                  sx={{ backgroundColor: "#3B82F60A", borderRadius: "6px" }}
                >
                  <h5 className="Text-Prime-Black poppinsMedium text-left pt-2">
                    Basic Details
                  </h5>
                  <Divider
                    className="mt-2 w-100"
                    sx={{ border: "1px solid #a7aba96e" }}
                  />
                  <Grid
                    item
                    container
                    lg={12}
                    xs={12}
                    justifyContent={"space-between"}
                    className="mt-3"
                  >
                    {basicDetails?.map((item, index) => {
                      return (
                        <>
                          {item.input == "dropdown" ? (
                            <> 
                            
                              <Grid
                                item
                                container
                                lg={3.8}
                                md={3.8}
                                sm={12}
                                xs={12}
                                
                                className="mt-2"
                                flexDirection={"column"}
                              >
                                <p className="text-black poppinsMedium pb-2 text-left">
                                  {item.name}
                                </p>
                                {
                                  item.name =="State of Origin"||item.name =="Local Government Area"||
                                  item.name =="Gender"?
                                    <CustomInput
                                      backgroundColor="#EEECEC"
                                      width={"100%"}
                                      height={"45px"}
                                      placeholderColor={"#666666"}
                                      padding={"2.5% 3% 2.5% 0%"}
                                      border={"1px solid  #666666"}
                                      fontFamily={"PoppinsMedium"}
                                      placeholder={"Enter your " + item.name}
                                      maxLength={100}
                                      value={item.value}
                                      disabled={true}
                                      onChange={(e) =>
                                        HandleBasicinfo(e.target.value, index)
                                      }
                                    />
                                    :
                                    <CustomDropDown
                                      placeholder={"Select your " + item.name}
                                      data={
                                        item.name == "Title"
                                          ? TitleInfo
                                          : item.name == "Gender" ? GenderInfo : item.name == "Marital Status" ? MaritalStatusInfo    : item.name == "Religion" ? NigeriaReligions : NigeriaStatesInfo
                                      }
                                      borderRadius={"8px"}
                                      backgroundColor="#FFFFFF"
                                      isDisabled={item.name=="State of Origin"? true:false}
                                      selected={
                                        item?.value && {
                                          label: item.value,
                                          value: item.value,
                                        }
                                      }
                                      onChange={(e) =>
                                        HandleBasicinfo(e.value, index)
                                      }
                                    />}                              
                              </Grid>
                            </>
                          ) :item.name == "Permanent Home Address" ? (
                            <Grid
                              item
                              container
                              lg={3.8}
                              md={3.8}
                              sm={12}
                              xs={12}
                              className="mt-2"
                              flexDirection={"column"}
                            >
                              <p className="text-black poppinsMedium pb-2 text-left">
                                {item.name}
                              </p>
                              <Grid>

                                <CustomInput
                                  backgroundColor="#EEECEC"
                                  width={"100%"}
                                  height={"45px"}
                                  placeholderColor={"#666666"}
                                  padding={"2.5% 3% 2.5% 0%"}
                                  border={"1px solid  #666666"}
                                  fontFamily={"PoppinsMedium"}
                                  placeholder={"Enter your " + item.name}
                                  maxLength={100}
                                  value={item.value}
                                  disabled={true}
                                  onChange={(e) =>
                                    HandleaddressPermanent(e.target.value, index)
                                  }
                                />
                              </Grid>
                             
                            </Grid>
                          ) :item.name == "Present Residential Address" ? (
                            <Grid
                              item
                              container
                              lg={3.8}
                              md={3.8}
                              sm={12}
                              xs={12}
                              className="mt-2"
                              flexDirection={"column"}
                            >
                              <p className="text-black poppinsMedium pb-2 text-left">
                                {item.name}
                              </p>
                              <Grid>
                                <AutoComplete
                                  placeholder={"Enter Residential Address"}
                                  Location={Residentialaddeess?.Address}
                                  setLocation={(e) => HandleaddressResidential(e, index)}
                                  height={"30px"}
                                />
                              </Grid>
                             
                            </Grid>
                          ): item.input == "text" ? (
                            <Grid
                              item
                              container
                              lg={3.8}
                              md={3.8}
                              sm={12}
                              xs={12}
                              className="mt-2"
                              flexDirection={"column"}
                            >
                              <p className="text-black poppinsMedium pb-2 text-left">
                                {item.name =="Surname"?"First Name" :item.name}
                              </p>
                              <CustomInput
                                backgroundColor={ item.name == "Surname" ||
                                  item.name == "Last Name" ||item.name == "Email" ? "#EEECEC":"#FFFFFF"}
                                width={"100%"}
                                height={"45px"}
                                placeholderColor={"#666666"}
                                padding={"2.5% 3% 2.5% 0%"}
                                border={"1px solid  #666666"}
                                fontFamily={"PoppinsMedium"}
                                placeholder={"Enter your " + item.name}
                                maxLength={100}
                                value={item.value}

                                disabled={
                                  item.name == "Surname" ||
                                  item.name == "Last Name" ||item.name == "Email"
                                    ? true   : item.name=="Other Languages Spoken"? basicDetails[14].value?.indexOf("Others") !=-1  ? false  : true :false
                                }
                                onChange={(e) =>
                                  HandleBasicinfo(e.target.value, index)
                                }
                              />
                            </Grid>
                          ) : item.input == "date" ? (
                            <Grid
                              item
                              container
                              lg={3.8}
                              md={3.8}
                              sm={12}
                              xs={12}
                              className="mt-2"
                              flexDirection={"column"}
                            >
                              <p className="text-black poppinsMedium pb-2 text-left">
                                {item.name}
                              </p>
                              {item.name =="Date of Birth"?
                                <CustomInput
                                  backgroundColor="#EEECEC"
                                  width={"100%"}
                                  height={"45px"}
                                  placeholderColor={"#666666"}
                                  padding={"2.5% 3% 2.5% 0%"}
                                  border={"1px solid  #666666"}
                                  fontFamily={"PoppinsMedium"}
                                  placeholder={"Enter your " + item.name}
                                  maxLength={100}
                                  value={item.value}
                                  disabled={true}
                                />
                                :
                                <CustomInput
                                  backgroundColor="#FFFFFF"
                                  width={"100%"}
                                  height={"45px"}
                                  placeholderColor={"#666666"}
                                  padding={"2.5% 3% 2.5% 0%"}
                                  border={"1px solid  #666666"}
                                  fontFamily={"PoppinsMedium"}
                                  placeholder={"Enter your " + item.name}
                                  maxLength={100}
                                  maxDate={maxDate}
                                  type={"date"}
                                  value={item.value}
                                  onChange={(e) =>
                                    HandleBasicinfo(e.target.value, index)
                                  }
                                />
                              }
                            </Grid>
                          ) : item.input == "check" ? (
                            <Grid
                              item
                              container
                              lg={3.8}
                              md={3.8}
                              sm={12}
                              xs={12}
                              className="mt-2"
                            >
                              <p className="Text-Prime-Black poppinsMedium pb-2 text-left">
                                Languages Spoken
                              </p>
                              <Grid item container lg={12} flexWrap={"wrap"}>

                                <Grid
                                  item
                                  container
                                  lg={4}
                                  alignItems={"center"}
                                >
                                  <CustomCheckBox
                                    disableColor={"transparent"}
                                    checked={
                                      item.value?.indexOf("English") !=-1  ? true : false
                                    }
                                    onChange={() =>
                                      HandleBasicinfoCheck("English", index)
                                    }
                                  />
                                  <p className="poppinsRegular Text-Prime-Gray text-left">
                                    English
                                  </p>
                                </Grid>
                                <Grid
                                  item
                                  container
                                  lg={4}
                                  alignItems={"center"}
                                >
                                  <CustomCheckBox
                                    disableColor={"transparent"}
                                    checked={
                                      item.value?.indexOf("Hausa") !=-1  ? true : false
                                    }
                                    onChange={() =>
                                      HandleBasicinfoCheck("Hausa", index)
                                    }
                                  />
                                  <p className="poppinsRegular Text-Prime-Gray text-left">
                                    Hausa
                                  </p>
                                </Grid>
                                <Grid
                                  item
                                  container
                                  lg={4}
                                  alignItems={"center"}
                                >
                                  <CustomCheckBox
                                    disableColor={"transparent"}
                                    checked={
                                      item.value?.indexOf("Igbo") !=-1  ? true : false
                                    }
                                    onChange={() =>
                                      HandleBasicinfoCheck("Igbo", index)
                                    }
                                  />
                                  <p className="poppinsRegular Text-Prime-Gray text-left">
                                    Igbo
                                  </p>
                                </Grid>
                                <Grid
                                  item
                                  container
                                  lg={4}
                                  alignItems={"center"}
                                >
                                  <CustomCheckBox
                                    disableColor={"transparent"}
                                    checked={
                                      item.value?.indexOf("Yoruba") !=-1  ? true : false
                                    }
                                    onChange={() =>
                                      HandleBasicinfoCheck("Yoruba", index)
                                    }

                                  />
                                  <p className="poppinsRegular Text-Prime-Gray text-left">
                                    Yoruba
                                  </p>
                                </Grid>
                                <Grid
                                  item
                                  container
                                  lg={4}
                                  alignItems={"center"}
                                >
                                  <CustomCheckBox
                                    disableColor={"transparent"}
                                    checked={
                                      item.value?.indexOf("Others") !=-1  ? true : false
                                    }
                                    onChange={() =>
                                      HandleBasicinfoCheck("Others", index)
                                    }

                                  />
                                  <p className="poppinsRegular Text-Prime-Gray text-left">
                                    Others
                                  </p>
                                </Grid>
                              </Grid>
                            </Grid>
                          ) : (
                            item.input == "phone" && (
                              <Grid
                                item
                                container
                                lg={3.8}
                                md={3.8}
                                sm={12}
                                xs={12}
                                flexDirection={"column"}
                                className="mt-2"
                              >
                                <p className="Text-Prime-Black poppinsMedium pb-2 text-left">
                                  {item.name}
                                </p>
                                <CustomInput
                                  placeholder="E.g. XXX XXX XXXX"
                                  backgroundColor="#FFFFFF"
                                  width={"100%"}
                                  height={"45px"}
                                  placeholderColor={"#666666"}
                                  padding={"2.5% 3% 2.5% 2%"}
                                  border={"1px solid  #666666"}
                                  fontFamily={"PoppinsMedium"}
                                  maxLength={10}
                                  type="number"
                                  value={item.value}
                                  disabled={
                                    item.name == "Main Phone Number"
                                      ? true
                                      : false
                                  }
                                  InputFrontProps={
                                    <p className="Text-Prime-Black  poppinsMedium pr-1" style={{wordBreak:"unset"}} >
                                      +234
                                    </p>
                                  }
                                  InputProps={
                                    <BiSolidPhone color={"#666666"} size={24} />
                                  }
                                  onChange={(e) =>
                                    HandleBasicinfo(e.target.value, index)
                                  }
                                />
                              </Grid>
                            )
                          )}
                        </>
                      );
                    })}
                  </Grid>
                </Grid>
                <Grid
                  container
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  className="p-3 borderRadius10 mt-3"
                  backgroundColor={"#3B82F60A"}
                >
                  <Grid
                    item
                    container
                    lg={12}
                    md={12}
                    sm={12}
                    alignItems={"center"}
                  >
                    <h4 className="Text-Prime-Black poppinsMedium text-left pl-2">
                      Next of Kin Details
                    </h4>
                  </Grid>
                  <Divider
                    className="mt-3 w-100"
                    sx={{ border: "1px solid #a7aba96e" }}
                  />
                  <Grid item container lg={12} xs={12} className="mt-3">
                    {KinDetails?.map((item, index) => {
                      return (
                        <>
                          {item.input == "text" ? (
                            <Grid
                              item
                              container
                              lg={3.8}
                              md={3.8}
                              sm={12}
                              xs={12}
                              className="m-2"
                              flexDirection={"column"}
                            >
                              <p className="text-black poppinsMedium pb-2 text-left">
                                {item.name}
                              </p>
                              <CustomInput
                                backgroundColor="#FFFFFF"
                                width={"100%"}
                                height={"45px"}
                                placeholderColor={"#666666"}
                                padding={"2.5% 3% 2.5% 0%"}
                                border={"1px solid  #666666"}
                                fontFamily={"PoppinsMedium"}
                                placeholder={"Enter " + item.name}
                                maxLength={100}
                                value={item.value}
                                onChange={(e) =>
                                  HandleKindetails(e.target.value, index)
                                }
                              />
                            </Grid>
                          ) : item.input == "dropdown" ? (
                            <Grid
                              item
                              container
                              lg={3.8}
                              md={3.8}
                              sm={12}
                              xs={12}
                              className="m-2"
                              flexDirection={"column"}
                            >
                              <p className="text-black poppinsMedium pb-2 text-left">
                                Relationship
                              </p>
                              <CustomDropDown
                                placeholder={"Select Relationship"}
                                data={RelationshipData}
                                borderRadius={"8px"}
                                backgroundColor="#FFFFFF"
                                selected={
                                  item?.value && {
                                    label: item.value,
                                    value: item.value,
                                  }
                                }
                                onChange={(e) =>
                                  HandleKindetails(e.value, index)
                                }
                              />
                            </Grid>
                          ) : item.input == "phone" ? (
                            <Grid
                              item
                              container
                              lg={3.8}
                              md={3.8}
                              sm={12}
                              xs={12}
                              className="m-2"
                              flexDirection={"column"}
                            >
                              <p className="Text-Prime-Black poppinsMedium pb-2 text-left">
                                Main Phone Number
                              </p>
                              <CustomInput
                                placeholder="E.g. XXX XXX XXXX"
                                backgroundColor="#FFFFFF"
                                width={"100%"}
                                height={"45px"}
                                placeholderColor={"#666666"}
                                padding={"2.5% 3% 2.5% 2%"}
                                border={"1px solid  #666666"}
                                fontFamily={"PoppinsMedium"}
                                maxLength={10}
                                type="number"
                                value={item.value}
                                InputFrontProps={
                                  <p className="Text-Prime-Black poppinsMedium pr-2" style={{wordBreak:"unset"}}>
                                    +234
                                  </p>
                                }
                                InputProps={
                                  <BiSolidPhone color={"#666666"} size={24} />
                                }
                                onChange={(e) =>
                                  HandleKindetails(e.target.value, index)
                                }

                              />
                            </Grid>
                          ) : (
                            item.input == "address" && (
                              <Grid
                                item
                                container
                                className="mt-2"
                                lg={3.8}
                                md={3.8}
                                sm={12}
                                xs={12}
                              >
                                <p className="Text-Prime-Black poppinsMedium pb text-left">
                                  {item.name}
                                </p>
                                <AutoComplete
                                  placeholder={"Enter Address"}
                                  Location={Baseaddeess?.Address}
                                  setLocation={(e) => Handleaddress(e, index)}
                                  height={"30px"}
                                />
                              </Grid>
                            )
                          )}
                        </>
                      );
                    })}
                  </Grid>
                </Grid>
                <Grid
                  container
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  className="p-3 mt-3"
                >
                  <Grid
                    item
                    container
                    lg={12}
                    md={12}
                    sm={12}
                    justifyContent={"flex-end"}
                    alignItems={"flex-end"}
                  >
                    <PrimeGrayBorderColorButton
                      type="submit"
                      className="px-3 py-2"
                      onClick={() => navigate("/")}
                    >
                      Back
                    </PrimeGrayBorderColorButton>
                    <GreenColorButton
                      type="submit"
                      className="px-3 py-2 mx-2"
                      onClick={() => ApplicationComplete()}
                    >
                      Save & Next
                    </GreenColorButton>
                  </Grid>
                </Grid>
              </Grid>
            ) : stepper == 1 ? (
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <EducationalQualification
                  kindetails={KinDetails}
                  setShowLoader={setShowLoader}
                  setkindetails={setKinDetails}
                  informations={informations}
                  referees={Referees}
                  affirmationss={affirmation}
                  affirmation={setaffirmation}
                  setEducationsDetails={setEducationQualification}
                  EducationsDetails={EducationQualification}
                  EducationQualificationsInfo={EducationQualificationsInfo}
                />
                <Grid
                  container
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  className="p-3 mt-3"
                >
                  <Grid
                    item
                    container
                    lg={12}
                    md={12}
                    sm={12}
                    justifyContent={"flex-end"}
                    alignItems={"flex-end"}
                  >
                    <PrimeGrayBorderColorButton
                      type="submit"
                      className="px-3 py-2"
                      onClick={()=>GoBacktopage()}
                    >
                      Previous
                    </PrimeGrayBorderColorButton>
                    <GreenColorButton
                      type="submit"
                      className="px-3 py-2 mx-2"
                      onClick={() => EducationComplete()}
                    >
                      Save & Next
                    </GreenColorButton>
                  </Grid>
                </Grid>
              </Grid>
            ) : stepper == 2 ? (
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <CandidateOtherDetails
                  referenceDetails={referenceDetails}
                  setReferenceDetails={setReferenceDetails}
                  furtherInformation={furtherInformation}
                  physicalTest={physicalTest}
                  setPhysicalTest={setPhysicalTest}
                  setFurtherInformation={setFurtherInformation}
                  otherDetails={otherDetails}
                  setOtherDetails={setOtherDetails}
                  PhysicalList={PhysicalList}
                  CBTList={CBTList}
                  Referees={Referees}
                  informations={informations}
                />
                <Grid
                  container
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  className="p-3 mt-3"
                >
                  <Grid
                    item
                    container
                    lg={12}
                    md={12}
                    sm={12}
                    justifyContent={"flex-end"}
                    alignItems={"flex-end"}
                  >
                    <PrimeGrayBorderColorButton
                      type="submit"
                      onClick={()=>GoBacktopage()}
                      className="px-3 py-2"
                    >
                      Previous
                    </PrimeGrayBorderColorButton>
                    <GreenColorButton
                      type="submit"
                      className="px-3 py-2 mx-2"
                      onClick={() => CompleteOtherDetails()}
                    >
                      Save & Next
                    </GreenColorButton>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              stepper == 3 && (
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid item lg={12} xs={12} className="px-3">
                    <Grid
                      item
                      lg={12}
                      sm={12}
                      md={12}
                      xs={12}
                      container
                      className="px-2 py-2"
                      alignItems={"center"}
                    >
                      <img
                        src={PSCLogo}
                        alt="PSCLogo"
                        height={60}
                        width={60}
                        className="img_fluid"
                      />
                      <h3 className="mx-2 poppinsSemiBold Text-Prime-Black text-center">
                        {/* Police Service Commission */}
                        {jobDetails?.job_name ? jobDetails.job_name : "---"}
                      </h3>
                    </Grid>
                    <Divider
                      className="w-100"
                      sx={{ border: "1px solid #a7aba96e" }}
                    />
                    <Grid
                      item
                      lg={12}
                      sm={12}
                      md={12}
                      xs={12}
                      container
                      className="p-2"
                      alignItems={"center"}
                      justifyContent={"space-between"}
                    >
                      <Grid
                        item
                        lg={10}
                        sm={10}
                        md={10}
                        xs={10}
                        container
                        className="p-2"
                        alignItems={"center"}
                      >
                        <Grid
                          item
                          lg={12}
                          sm={12}
                          md={12}
                          xs={12}
                          container
                          className="py-2"
                          justifyContent={"space-between"}
                        >
                          <Grid item lg={6} sm={6} md={6} xs={6}>
                            <p className="poppinsMedium Text-Prime-Black text-left">
                              Name of the Post Applying for
                            </p>
                          </Grid>
                          <Grid item lg={6} sm={6} md={6} xs={6}>
                            <p className="poppinsRegular Text-Prime-Black text-left">
                              {jobDetails?.job_name
                                ? jobDetails?.job_name
                                : "--"}
                            </p>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          lg={12}
                          sm={12}
                          md={12}
                          xs={12}
                          container
                          style={{ borderBottom: "2px dotted black" }}
                        />
                        <Grid
                          item
                          lg={12}
                          sm={12}
                          md={12}
                          xs={12}
                          container
                          className="py-2"
                          justifyContent={"space-between"}
                        >
                          <Grid item lg={6} sm={6} md={6} xs={6}>
                            <p className="poppinsMedium Text-Prime-Black text-left">
                              Notification Number
                            </p>
                          </Grid>
                          <Grid item lg={6} sm={6} md={6} xs={6}> 
                            <p className="poppinsRegular Text-Prime-Black text-left">
                              {jobDetails?.job_post_number
                                ? jobDetails?.job_post_number
                                : "--"}
                            </p>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          lg={12}
                          sm={12}
                          md={12}
                          xs={12}
                          container
                          style={{ borderBottom: "2px dotted black" }}
                        />
                      </Grid>
                      <Grid
                        item
                        lg={2}
                        sm={2}
                        md={2}
                        xs={2}
                        container
                        justifyContent={"flex-end"}
                      >
                        <img
                          src={ProfileIMAGES1}
                          alt="PSCLogo"
                          height={"150px"}
                          width={"150px"}
                          className="img_fluid"
                        />
                      </Grid>
                    </Grid>
                    <ApplicationDetails
                      refereeinformation={Referees}
                      affirmation={affirmation}
                      furtherinformation={furtherInformation}
                      Data={basicDetails}
                      EducationQualification={EducationQualification}
                      kindetails={KinDetails}
                      PhysicalList={physicalTest}
                      isShowAll={true}
                      CandidateDetail={CandidateDetail}
                      otherDetails={otherDetails}
                      physicalTestLocations={physical_locations}
                      MedicalTestLocations={medical_locations}
                      ComputerTestLocations={computer_locations}
                      EducationQualifications={EducationQualification}
                      // refereeinformation={}
                      Affirmationcheck={Affirmationcheck}
                      setAffirmationcheck={setAffirmationcheck}
                    />
                    <Grid
                      item
                      container
                      lg={12}
                      xs={12}
                      justifyContent={"space-between"}
                      className="mt-3"
                    >
                      <Grid
                        item
                        container
                        lg={3.8}
                        md={3.8}
                        sm={12}
                        xs={12}
                        flexDirection={"column"}
                      >
                        <p className="Text-Prime-Black poppinsMedium pb-2 text-left">
                          Submitted on Date
                        </p>
                        <DatePicker
                          isFuture={true}
                          placeholder={"DD/MM/YYYY"}
                          height={"45px"}
                          disabled={true}
                          fontFamily={"PoppinsMedium"}
                          backgroundColor="#FFFFFF"
                          border={"1px solid  #666666"}
                          Value={submittedDate}
                          handleInput={(e) => console.log(e)}
                        />
                      </Grid>
                      <Grid
                        item
                        container
                        lg={4}
                        md={4}
                        sm={12}
                        xs={12}
                        flexDirection={"column"}
                      >
                        <p className="Text-Prime-Black poppinsMedium pb-2 text-left">
                          Submitted on Place
                        </p>

                        <Grid
                          item
                          container
                          placeholderColor={"#666666"}
                          backgroundColor="#FFFFFF"
                          lg={7}
                          md={8}
                          sm={12}
                          xs={12}
                        >
                          <AutoComplete
                            placeholder={"Enter Place Name"}
                            Location={placeName?.Address}
                            setLocation={(e) => setPlaceName(e)}
                            height={"30px"}
                          />
                        </Grid>
                      </Grid>
                      <Grid item container lg={4} md={4} sm={12} xs={12} />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    item
                    lg={12}
                    sm={12}
                    md={12}
                    xs={12}
                    className="p-3 mt-3"
                  >
                    <Grid
                      item
                      container
                      lg={12}
                      md={12}
                      sm={12}
                      justifyContent={"flex-end"}
                      alignItems={"flex-end"}
                    >
                      <PrimeGrayBorderColorButton
                        type="submit"
                        className="px-3 py-2"
                        onClick={() => PreviewBack()}
                      >
                        Previous
                      </PrimeGrayBorderColorButton>
                      <GreenColorButton
                        type="submit"
                        className="px-3 py-2 mx-2"
                        onClick={() => CompletePreview()}
                      >
                        Save & Next
                      </GreenColorButton>
                    </Grid>
                  </Grid>
                </Grid>
              )
            )}
          </Grid>
        </Grid>
      )}

      <CustomModal
        open={conformModal}
        setOpen={setConformModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={
          <Grid
            item
            container
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <CiCircleQuestion color={"#12A59B"} size={100} />
            <p className="poppinsRegular Text-Prime-Black pt-3 text-center">
              Are you sure you want to submit?
            </p>
            <p className="poppinsLight Text-Prime-Gray pt-3 text-center">
              Ensure all details are correct before final submission.
            </p>
          </Grid>
        }
        modalFooter={
          <Grid item container display={"flex"} justifyContent={"center"}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-5 py-2"
              onClick={() => setConformModal(false)}
            >
              No
            </PrimeGrayBorderColorButton>
            <DarkGreenColorButton
              type="submit"
              className="px-5 py-2 ml-2"
              onClick={() => HandleComplete()}
            >
              Yes
            </DarkGreenColorButton>
          </Grid>
        }
      />
      <CustomModal
        open={detailModal}
        setOpen={CloseDetailModal}
        divider={false}
        header={true}
        contentScroll={true}
        modalTitle={
          <h5 className="poppinsSemiBold Text-Prime-Black text-left">
            View Post Details
          </h5>
        }
        width={window.innerWidth > 600 ? "55%" : "95%"}
        modalContent={
          <Grid
            item
            container
            flexDirection={"column"}
            justifyContent={"flex-start"}
            alignItems={"flex-start"}
            textAlign={"left"}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              container
              justifyContent={"space-between"}
            >
              <Grid
                item
                container
                lg={2.8}
                md={5.8}
                sm={12}
                xs={12}
                flexDirection={"column"}
              >
                <p className="text-black poppinsMedium pb-2 text-left">
                  Post Name
                </p>
                <p className="poppinsNormal Text-Prime-Black text-left">
                  {jobDetails?.job_name ? jobDetails?.job_name : "--"}
                </p>
              </Grid>
              <Grid
                item
                container
                lg={2.8}
                md={5.8}
                sm={12}
                xs={12}
                flexDirection={"column"}
              >
                <p className="text-black poppinsMedium pb-2 text-left">
                  Start Date
                </p>
                <p className="poppinsNormal Text-Prime-Black  text-left">
                  {jobDetails?.job_start_date
                    ? OnlyDateConverter(jobDetails?.job_start_date)
                    : "--"}
                </p>
              </Grid>
              <Grid
                item
                container
                lg={2.8}
                md={5.8}
                sm={12}
                xs={12}
                flexDirection={"column"}
              >
                <p className="text-black poppinsMedium pb-2 text-left">
                 Close Date
                </p>
                <p className="poppinsNormal Text-Prime-Black text-left">
                  {jobDetails?.job_end_date
                    ? OnlyDateConverter(jobDetails?.job_end_date)
                    : "--"}
                </p>
              </Grid>
              <Grid
                item
                container
                lg={2.8}
                md={5.8}
                sm={12}
                xs={12}
                flexDirection={"column"}
              >
                <p className="text-black poppinsMedium pb-2 text-left">
                  Number of Opening
                </p>
                <p className="poppinsNormal Text-Prime-Black text-left">
                  {jobDetails?.openings_count
                    ? FormatAmount(jobDetails?.openings_count)
                    : "--"}
                </p>
              </Grid>
            </Grid>
            <Divider
              className="w-100 mt-2"
              sx={{ border: "1px solid #a7aba96e" }}
            />

            <p className="poppinsNormal Text-Prime-Black pt-2 text-left">
              Here are the basic requirements for the role of Cadet Assistant
              Superintendent of Police (ASP):
            </p>
            <h5 className="poppinsSemiBold Text-Prime-Black pt-3 text-left">
              Qualification:
            </h5>
            {jobDetails?.job_qualifications?.filter(item => item.value).map((items, index) => {
              return (
                <> {items.value && 
                <p
                  key={index}
                  className="poppinsNormal Text-Prime-Black pt-3 text-left"
                >
                  {index + 1}. {items.name}
                </p>}</>
              );
            })}
          </Grid>
        }
        modalFooter={
          <Grid item container display={"flex"} justifyContent={"flex-end"}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-5"
              onClick={() => CloseDetailModal()}
            >
              Close
            </PrimeGrayBorderColorButton>
          </Grid>
        }
      />
      <CustomModal
        open={applicationAgreement}
        setOpen={CloseAgreementModal}
        divider={false}
        header={true}
        contentScroll={true}
        modalTitle={
          <h5 className="poppinsSemiBold Text-Prime-Black text-left">
            Application Agreement
          </h5>
        }
        width={window.innerWidth > 600 ? "60%" : "95%"}
        modalContent={
          <Grid
            item
            container
            flexDirection={"column"}
            justifyContent={"flex-start"}
            alignItems={"flex-start"}
            textAlign={"left"}
            className="px-2"
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              container
              justifyContent={"space-between"}
            >
              <Grid
                item
                container
                lg={2.8}
                md={5.8}
                sm={12}
                xs={12}
                flexDirection={"column"}
              >
                <p className="text-black poppinsMedium pb-2 text-left">
                  Post Name
                </p>
                <p className="poppinsNormal Text-Prime-Black text-left">
                  {jobDetails?.job_name ? jobDetails?.job_name : "--"}
                </p>
              </Grid>
              <Grid
                item
                container
                lg={2.8}
                md={5.8}
                sm={12}
                xs={12}
                flexDirection={"column"}
              >
                <p className="text-black poppinsMedium pb-2 text-left">
                  Start Date
                </p>
                <p className="poppinsNormal Text-Prime-Black  text-left">
                  {jobDetails?.job_start_date
                    ? OnlyDateConverter(jobDetails?.job_start_date)
                    : "--"}
                </p>
              </Grid>
              <Grid
                item
                container
                lg={2.8}
                md={5.8}
                sm={12}
                xs={12}
                flexDirection={"column"}
              >
                <p className="text-black poppinsMedium pb-2 text-left">
                  Close Date
                </p>
                <p className="poppinsNormal Text-Prime-Black text-left">
                  {jobDetails?.job_end_date
                    ? OnlyDateConverter(jobDetails?.job_end_date)
                    : "--"}
                </p>
              </Grid>
              <Grid
                item
                container
                lg={2.8}
                md={5.8}
                sm={12}
                xs={12}
                flexDirection={"column"}
              >
                <p className="text-black poppinsMedium pb-2 text-left">
                  Number of Opening
                </p>
                <p className="poppinsNormal Text-Prime-Black text-left">
                  {jobDetails?.openings_count
                    ? FormatAmount(jobDetails?.openings_count)
                    : "--"}
                </p>
              </Grid>
            </Grid>
            <Divider
              className="w-100 mt-2"
              sx={{ border: "1px solid #a7aba96e" }}
            />

            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              container
              flexDirection={"column"}
            >
              <h5 className="poppinsSemiBold Text-Prime-Black pt-3 text-left">
                Instructions for the Candidate:
              </h5>
              <p className="poppinsNormal Text-Prime-Black pt-2 text-left">
                Please review and agree to the terms before proceeding with your
                application.
              </p>
              <p className="poppinsNormal Text-Prime-Black pt-2 text-left">
                1. Accuracy of Information:{" "}
              </p>
              <p className="poppinsNormal Text-Prime-Black p-2 text-left">
                I confirm that all information provided in this application is
                accurate and true to the best of my knowledge. Any falsification
                may result in disqualification or legal consequences.
              </p>
              <p className="poppinsNormal Text-Prime-Black pt-2 text-left">
                2. Eligibility Criteria:
              </p>
              <p className="poppinsNormal Text-Prime-Black p-2 text-left">
                I confirm that I meet the minimum qualifications, educational
                requirements, and other eligibility criteria specified for this
                government position.
              </p>
              <p className="poppinsNormal Text-Prime-Black pt-2 text-left">
                3. Documentation Requirements:
              </p>
              <p className="poppinsNormal Text-Prime-Black p-2 text-left">
                I understand that I must provide all required documentation
                (e.g., national ID, educational certificates, professional
                qualifications) at each stage of the application process.
              </p>
              <p className="poppinsNormal Text-Prime-Black pt-2 text-left">
                4. Stage Completion:
              </p>
              <p className="poppinsNormal Text-Prime-Black p-2 text-left">
                I agree to complete all stages of the recruitment process
                (physical test, CBT, medical test) as required. Failure to
                complete any stage may lead to my disqualification.
              </p>
              <p className="poppinsNormal Text-Prime-Black pt-2 text-left">
                5. Compliance with Government Policies:
              </p>
              <p className="poppinsNormal Text-Prime-Black p-2 text-left">
                {" "}
                I understand that I must comply with all government rules,
                policies, and regulations associated with this recruitment
                process.{" "}
              </p>
              <p className="poppinsNormal Text-Prime-Black pt-2 text-left">
                6. Final Decision:{" "}
              </p>
              <p className="poppinsNormal Text-Prime-Black p-2 text-left">
                {" "}
                I acknowledge that the final selection decision rests solely
                with the recruitment board, and my application status may be
                changed at any stage based on my compliance and performance.
              </p>
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              container
              flexDirection={"column"}
            >
              <Grid
                item
                container
                lg={12}
                md={12}
                sm={12}
                xs={12}
                flexWrap={"nowrap"}
                alignItems={"center"}
              >
                <CustomCheckBox
                  disableColor={"transparent"}
                  checked={aggrement.Q1 == true ? true : false}
                  onChange={() => ChangeAggrement(!aggrement.Q1, "Q1")}
                />
                <p className="poppinsNormal Text-Prime-Black text-left">
                  I have thoroughly reviewed the recruitment notification and
                  the instructions provided for applicants. I understand that it
                  is my responsibility to submit correct and error-free details.
                </p>
              </Grid>
              <Grid
                item
                container
                lg={12}
                md={12}
                sm={12}
                xs={12}
                flexWrap={"nowrap"}
                alignItems={"center"}
              >
                <CustomCheckBox
                  disableColor={"transparent"}
                  checked={aggrement.Q2 == true ? true : false}
                  onChange={() => ChangeAggrement(!aggrement.Q2, "Q2")}
                />
                <p className="poppinsNormal Text-Prime-Black text-left">
                  I will ensure that all information provided in the online
                  application is accurate and free of errors.
                </p>
              </Grid>
              <Grid
                item
                container
                lg={12}
                md={12}
                sm={12}
                xs={12}
                flexWrap={"nowrap"}
                alignItems={"center"}
              >
                <CustomCheckBox
                  disableColor={"transparent"}
                  checked={aggrement.Q3 == true ? true : false}
                  onChange={() => ChangeAggrement(!aggrement.Q3, "Q3")}
                />
                <p className="poppinsNormal Text-Prime-Black text-left">
                  I understand that it is my responsibility to submit correct
                  and error-free details.
                </p>
              </Grid>
            </Grid>
          </Grid>
        }
        modalFooter={
          <Grid item container display={"flex"} justifyContent={"flex-end"}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-3"
              sx={{marginX:"30px"}}
              onClick={() => CloseAgreementModal()}
            >
              Close
            </PrimeGrayBorderColorButton>
            <GreenColorButton
              className="px-3 py-2 mx-2 "
              onClick={() => OpenApplication()}
            >
              {verifyApplications && (
                <CircularProgress size="2rem" style={{ color: "#fff" }} />
              )}
              Agree & Proceed
            </GreenColorButton>
          </Grid>
        }
      />
    </Grid>
  );
};

export default CandidateJob;
